module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACwAAAAsCAYAAAAehFoBAAAAAXNSR0IArs4c6QAAAUBJREFUWAntlzEKwjAUhhvRUcRBBGfdXAVHT+ARPIxX8RJuugiii+ikCN5AxU0Q6h/JENIWXptHaOUFfvKSvrz8+bS2RpE0ISAEqkEgjuMu9IR0W4RyXfPYqI+1LbN+5FEn11Ifw7k24koWw1wks+oI4SwyXPOlI4yfyCm0gpZQ0z1o3Z0owXgGDxPjo4f+bOJfVzrCcGV7UrZZHdsX3WulHFfOcJDvMG4eDWYMNaCtUupd9OMLRVjfSBtoDc2hwi2U4Y7l0I6taVoYyjDNDSFLDBMgeaUIYS98hMVCmADJKyVBGE+lE6TbBUq8fHjtxrA4YRg1h6buAH2bYQ/WEmmGWTfgLiaGuYm69YSwS4R7LIS5ibr1/oLw0Zzqhv7hntAaXxG/zHhvzaeFB0x+iLk7k6f/991NLJ0QEAJCgEjgC9Y8P7eRJVoiAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon71.png
// module id = OmuS
// module chunks = 51